import { useParams } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { MobileSectionOverview, MobileSectionNavigation } from "@/components/MobileNavigationLandingPage";
import { useSectionNavLinks } from "./_utils";

export default function MobileSectionLandingPage() {
  const { sectionId } = useParams();
  const navLinks = useSectionNavLinks(sectionId);

  if (!sectionId) {
    return null;
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb compactOnly compactTitle="Manage Section" backLink={{ to: "/sections" }} />
      <MobileSectionOverview sectionId={sectionId} />
      <MobileSectionNavigation sectionId={sectionId} />
    </AppLayout>
  );
}
